module.exports = __webpack_public_path__ + "img/iconBlobCar.adf1f8bc.svg";